<template>
    <div>
        <search :btnConfig="btnConfig" @handleBtn="handleBtn" :searchConfig="searchConfig" :pageTitle="pageTitle"/>
        <el-table ref="table" :data="tableData" style="width: 99.9%" row-key="planId"
                  height="600" v-horizontal-scroll="'always'"
                  :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                  :row-class-name="tableRowClassName" @row-dblclick="cellDblclick" @row-click="rowClick">
            <el-table-column v-if="isSelectShow" header-align="center" align="center" type="selection"/>
            <template v-for="(config, index) in listConfig">
                <el-table-column v-if="config.expand" type="expand" header-align="center" align="center" width="20px"
                                 :key="index || config.key">
                    <template slot-scope="scope">
                        <slot v-if="config.expand" name="expand" :row="scope.row"/>
                    </template>
                </el-table-column>
                <el-table-column v-else header-align="center" align="center" :key="index || config.key"
                                 :label="config.title" :width="config.width">
                    <template slot-scope="scope">
                        <slot :name="config.key" :row="scope.row">
                              <span v-if="config.showData"
                                    :style="{ color: config.color ? getColor(config.color, scope.row[config.key], scope.row): '', cursor: config.callBack ? 'pointer' : 'default',}"
                                    @click="callBack(config, scope.row)">
                                    {{
                                      typeof config.showData === "object" ? config.showData[scope.row[config.key]] || config.showData.default : config.showData(scope.row)
                                  }}
                              </span>
                            <span v-else
                                  :style="{ color: config.color ? getColor(config.color, scope.row[config.key], scope.row) : '', cursor: config.callBack ? 'pointer' : 'default', }"
                                  @click="callBack(config, scope.row)">
                                {{ scope.row[config.key] }}
                              </span>
                        </slot>
                    </template>
                </el-table-column>
            </template>
        </el-table>
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageParams.current"
                    :page-sizes="[10, 100, 200, 300, 400]"
                    :page-size="pageParams.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageParams.total"/>
        </div>
        <from-list :fromConfig="fromConfig" :closeModal="closeModal" ref="fromList" @confirm="confirm">
            <slot v-for="message in getMessageNames" slot-scope="data" :slot="message" :name="message"
                  :from="data.from"/>
        </from-list>
    </div>
</template>

<script>
import search from "./search";
import {createProps} from "@/utils/createProps";
import {openMessageBox} from "@/utils";
import {export_json_to_excel} from "@/utils/Export2Excel";

export default {
    data() {
        return {
            currentPage4: 1,
            tableData: [],
            searchParams: {},
            pageParams: {
                current: 1,
                size: 10,
                total: 0,
            },
            fromConfig: [],
            detail: null
        };
    },
    props: {
        closeModal: createProps(true),
        isSelectShow: createProps(true),
        apis: createProps({}),
        idKey: createProps(""),
        messageName: [String, Array],
        createFrom: {type: Function},
        openFromFn: {type: Function},
        listConfig: createProps([]),
        btnConfig: createProps([]),
        searchConfig: createProps([]),
        pageTitle: createProps(""),
    },
    components: {
        search,
    },
    computed: {
        getColor() {
            return (color, key, data) => {
                if (typeof color === "object") {
                    return color[key] || color.default;
                } else if (typeof color === "function") {
                    return color(data);
                } else {
                    return color;
                }
            };
        },
        getBtn() {
            return this.btnConfig;
        },
        getMessageNames() {
            let _arr = [];
            if (typeof this.messageName === "string") {
                _arr = [this.messageName];
            } else {
                _arr = this.messageName;
            }
            return _arr;
        },
        getApis() {
            return this.apis;
        },
        getAdd() {
            return this.apis.add;
        },
        getUpdate() {
            return this.apis.update;
        },
        getApiFun() {
            return this.apis.list;
        },
        getDetailFun() {
            return this.apis.detail;
        },
        getDeleteFun() {
            return this.apis.deletes;
        },
        getIdKey() {
            return this.idKey;
        },
        getSearch() {
            return this.searchConfig;
        },
        getCreateFrom() {
            return this.createFrom;
        },
        _getOpenFromFn() {
            return this.openFromFn;
        }
    },
    created() {
        this.getList();
    },
    methods: {
        closeMessage() {
            this.$refs.fromList.close();
        },
        callBack(data, row) {
            if (data.callBack) this.$emit("callBack", {key: data.key, data: row});
        },
        rowClick(row) {
            this.$refs.table.toggleRowSelection(row);
            const _list = this.$refs.table.selection;
            const exportIndex = this.getBtn.findIndex(
                    (item) => item.key === "export"
            );
            if (exportIndex !== -1) this.getBtn[exportIndex].data = _list;
        },
        cellDblclick(row) {
            this.$emit("cellDblclick", row);
        },
        handleBtn(key, btn) {
            this.detail = null;
            if (key === "search") {
                let _params = {};
                this.getSearch.forEach((item) => {
                    if (item.value) {
                        _params[item.key] = item.value instanceof Array ? item.value.join(",") : item.value;
                    }
                });
                this.searchParams = _params;
                // 点击搜索按钮重置分页序号
                this.pageParams.current = 1
                this.getList();
            } else if (key === "add") {
                this.fromConfig = this.getCreateFrom();
                this.$refs.fromList.open();
            } else if (key === "update") {
                const _list = this.$refs.table.selection;
                if (btn.verification) btn.verification(_list);
                this.fromConfig = this.getCreateFrom();
                _list.length === 1 ? this.getDetail(_list[0][this.getIdKey]) : this.$error("请在列表中选中一项再编辑");
            } else if (key === "delete") {
                const _list = this.$refs.table.selection;
                if (btn.verification) btn.verification(_list);
                if (_list.length < 1) this.$error("请在列表中选中要删除的项");
                openMessageBox(
                        {
                            content: "此操作将永久删除, 是否继续?",
                        },
                        (boolean) => {
                            if (boolean) {
                                const ids = this.$refs.table.selection.map((item) => {
                                    return item[this.getIdKey];
                                });
                                this.deleteList(ids);
                            }
                        }
                );
            } else if (key === "export") {
                const toExport = (list) => {
                    const excelHeader = Object.keys(btn.header_data);
                    const excelData = [];
                    list.forEach((item) => {
                        const _data = [];
                        excelHeader.forEach((key) => {
                            if (typeof btn.header_data[key] === "object") {
                                const _transform = btn.header_data[key].transform;
                                const _key = btn.header_data[key].key;
                                const _showData = btn.header_data[key].showData;
                                if (_transform) {
                                    _data.push(btn.header_data[key].transform(item));
                                } else {
                                    _data.push(_showData[item[_key]]);
                                }
                            } else {
                                _data.push(item[btn.header_data[key]]);
                            }
                        });
                        excelData.push(_data);
                    });
                    export_json_to_excel(excelHeader, excelData, btn.label + Date.now());
                };
                let _list = this.$refs.table.selection;
                if (this.getApis.exportApi && _list.length < 1) {
                    // const ids = _list.map((item) => item[this.getIdKey]);
                    // this.getApis.exportApi(ids).then((res) => {
                    let _params = {};
                    this.getSearch.forEach((item) => {
                        if (item.value instanceof Array) {
                            if (item.value.length > 0) _params[item.key] = item.value.join(",");
                        } else if (item.value) {
                            _params[item.key] = item.value;
                        }
                    });
                    this.getApis.exportApi(_params).then((res) => {
                        toExport(res.data);
                    });
                } else {
                    const ids = _list.map((item) => item[this.getIdKey]);
                    this.getApis.exportApi({ids}).then((res) => {
                        toExport(res.data);
                    });
                }
            } else {
                const _list = this.$refs.table.selection;
                this.$emit("handleBtn", key, _list);
            }
            if (this._getOpenFromFn) this.$nextTick(this._getOpenFromFn);
        },
        async getDetail(id) {
            const [res] = await this.$ajax(this.getDetailFun, id);
            this.detail = res.data;
            this.$refs.fromList.open(this.detail);
        },
        async deleteList(ids) {
            if (ids.length < 1) this.openError("请选择要删除的项");
            const [res] = await this.$ajax(this.getDeleteFun, ids);
            if (res) this.getList();
        },
        async confirm() {
            const params = this.$params(this.fromConfig);
            let api = this.getAdd;
            if (this.detail) {
                params[this.getIdKey] = this.detail[this.getIdKey];
                api = this.getUpdate;
            }
            const [res] = await this.$ajax(api, params);
            if (res) {
                this.closeMessage();
                this.getList();
            }
        },
        async getList() {
            // return;
            const {current, size} = this.pageParams;
            let params = {
                current,
                size,
                ...this.searchParams,
            };
            const [res] = await this.$ajax(this.getApiFun, params);
            const {records, total} = res.data;
            this.pageParams.total = total;
            this.tableData = records;

            const exportIndex = this.getBtn.findIndex(
                    (item) => item.key === "export"
            );
            if (exportIndex !== -1) this.getBtn[exportIndex].defaultList = records;
        },
        tableRowClassName(row) {
            if (row.rowIndex % 2 === 0) {
                return "even";
            } else {
                return "odd";
            }
        },
        handleSizeChange(size) {
            this.pageParams.size = size;
            this.getList();
        },
        handleCurrentChange(current) {
            this.pageParams.current = current;
            this.getList();
        }
    },
};
</script>

<style lang="less" scoped>
.el-table {

    background-color: transparent;
}

/deep/ .odd {
    background: #ffffff;
}

/deep/ .even {
    background: #dde5ee;
}

/deep/ .has-gutter tr {
    font-size: 18px;
    color: #333333;
}

/deep/ .el-table__header-wrapper {
    margin-bottom: 0px;
}

/deep/ .el-table__row {
    font-size: 16px;
}

/deep/ .el-table td {
    border: none;
}

/deep/ .number {
    background: #f4f8fb;
    font-size: 16px !important;
}

/deep/ .btn-prev {
    background: #f4f8fb !important;
    font-size: 16px !important;
}

/deep/ .btn-next {
    background: #f4f8fb !important;
    font-size: 16px !important;
}

/deep/ .el-pagination .el-input__inner {
    background: #f4f8fb !important;
    font-size: 16px !important;
}

/deep/ .el-pagination__total {
    font-size: 16px !important;
}

/deep/ .el-pagination .el-icon {
    font-size: 16px !important;
}

/deep/ .el-pagination__jump {
    font-size: 16px !important;
}

/deep/ .el-table__expanded-cell {
    padding-left: 0;
    padding-right: 0;
    border-bottom: 1px solid #dddddd !important;
}
/deep/ .el-table--scrollable-x .el-table__body-wrapper{
  overflow-x: hidden;
}
.pagination {
    text-align: center;
    padding: 0;
}
</style>
